export default class ImageHelper {
    constructor() {
        this.width = null;
        this.height = null;
    }

    getClosestImageSize(img, sizes) {
        let width = null;
        let height = null;
        let wOne = img.width / 100;
        let hOne = img.height / 100;
        let newWidth = null;
        let newHeight = null;

        for(let i = 1; i <= 100; i++) {
            newWidth = img.width - (wOne * i);
            newHeight = img.height - (hOne * i);

            if(newWidth <= sizes.width && newHeight <= sizes.height) {
                width = newWidth;
                height = newHeight;
                break;
            }
        }

        this.width = width;
        this.height = height;

        return this;
    }

    getWidth() {
        return Math.round(this.width);
    }

    getHeight() {
        return Math.round(this.height);
    }
}